import { Suspense, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from '../components/navbar';
import FaqStatusBar from '../components/FaqStatusBar';
import { Fallback } from '../error/error-handling';
import Footer from './footer';
import styles from './index.module.scss';

const PublicLayout = ({
  surface = 'editorial',
  footerVariant = 'full',
  showFooterCta = true,
}) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname]);

  const layoutClass = surface === 'cinematic' || surface === 'conversion'
    ? styles.cloneLayout
    : styles.layout;

  return (
    <div
      className={`${layoutClass} public-site-layout public-surface public-surface--${surface}`}
      data-public-surface={surface}
    >
      {location.pathname === '/faqs' && <FaqStatusBar />}
      <Navbar />
      <Suspense fallback={<Fallback />}>
        <Outlet />
      </Suspense>
      {footerVariant !== 'hidden' && (
        <Footer
          hideEnquire={!showFooterCta}
          compact={footerVariant === 'compact'}
        />
      )}
    </div>
  );
};

PublicLayout.propTypes = {
  surface: PropTypes.oneOf(['cinematic', 'editorial', 'conversion', 'document']),
  footerVariant: PropTypes.oneOf(['full', 'compact', 'hidden']),
  showFooterCta: PropTypes.bool,
};

export default PublicLayout;
